export default __webpack_public_path__ + "static/media/python.56694bfa.png";